import React from 'react';
import times from 'lodash/times';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../CommonComponents/OPL/Shimmer/Shimmer';

export const ActionStepsReportLoading = () => {
  return (
    <Box>
      {times(4).map(key => (
        <Box
          key={key}
          display="flex"
          flexDirection="column"
          css="gap: 16px"
          borderBottom="1px solid"
          borderColor="neutral.200"
          p="16"
        >
          <Shimmer width={100} height={24} />

          {times(3).map(key2 => (
            <Box key={key2} display="flex" css="gap: 8px">
              <Shimmer width={16} height={16} />
              <Shimmer width={200} height={16} />

              <Shimmer width={16} height={16} ml="auto" />
              <Shimmer width={16} height={16} />
              <Shimmer width={16} height={16} />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};
